/**
 * Table colours by booking status. The staff floor plan uses these for every table, so a free table in a
 * red section is never mistaken for a booked one; its legend reads from the same values.
 */
export const TABLE_STATUS_COLOURS = {
  available: '#3a80c8',
  booked: '#e74c3c',
  deposit_pending: '#e6950a',
  seated: '#2ecc71',
} as const
